// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__w_ruY","col":"styles_col__3vf5e","actions":"styles_actions__2p7pm","conflict":"styles_conflict__1axh6"};